module.exports = __webpack_public_path__ + "static/img/ss.3861e5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/growthThinking/list4/ss.jpg
// module id = k02B
// module chunks = 1